"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var institutionList = {
  institutionCount: 30,
  institutions: [{
    slug: 'anznz',
    name: 'ANZ New Zealand',
    credentials: [{
      name: 'Customer Number',
      fieldID: 'username',
      type: 'text',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: '',
      defaultKey: '',
      optional: false
    }, {
      name: 'Password',
      fieldID: 'password',
      type: 'password',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: '',
      defaultKey: '',
      optional: false
    }],
    status: '',
    searchVal: 'anzaustralianewzealandaustraliaandnewzealandbankinggroup',
    exportWithPassword: false,
    requiresPreload: false,
    requiresMfa: false,
    isBusinessBank: false,
    region: 'nz',
    display: true
  }, {
    slug: 'aotearoa',
    name: 'Aotearoa Credit Union',
    credentials: [{
      name: 'AccessNumber',
      fieldID: 'username',
      type: 'text',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }, {
      name: 'Password',
      fieldID: 'password',
      type: 'password',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }],
    status: '',
    searchVal: 'aotearoacreditunionaotearoacu',
    exportWithPassword: false,
    requiresPreload: false,
    requiresMfa: false,
    isBusinessBank: false,
    region: 'nz',
    display: false
  }, {
    slug: 'asb',
    name: 'ASB',
    credentials: [{
      name: 'Username',
      fieldID: 'username',
      type: 'text',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: '',
      defaultKey: '',
      optional: false
    }, {
      name: 'Password',
      fieldID: 'password',
      type: 'password',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: '',
      defaultKey: '',
      optional: false
    }],
    status: '',
    searchVal: 'asbcbaallblacks',
    exportWithPassword: false,
    requiresPreload: false,
    requiresMfa: false,
    isBusinessBank: false,
    region: 'nz',
    display: true
  }, {
    slug: 'bank_of_captcha',
    name: 'Bank of CAPTCHA',
    credentials: [{
      name: 'Username',
      fieldID: 'username',
      type: 'text',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }, {
      name: 'Password',
      fieldID: 'password',
      type: 'password',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }, {
      name: 'Enter Text Shown',
      fieldID: 'captcha',
      type: 'captcha',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }],
    status: 'We are currently experiencing issues in retrieving data from this institution. If you experience any problems, please try again later.',
    searchVal: 'bankofcaptchademotest',
    exportWithPassword: false,
    requiresPreload: true,
    requiresMfa: false,
    isBusinessBank: false,
    region: '',
    display: false
  }, {
    slug: 'bank_of_custom',
    name: 'Bank of Custom Data',
    credentials: [{
      name: 'Username',
      fieldID: 'username',
      type: 'text',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }, {
      name: 'Password',
      fieldID: 'password',
      type: 'password',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }],
    status: '',
    searchVal: 'testbankofcustomdatademonstration',
    exportWithPassword: false,
    requiresPreload: false,
    requiresMfa: false,
    isBusinessBank: false,
    region: '',
    display: false
  }, {
    slug: 'bank_of_mfa',
    name: 'Bank of MFA',
    credentials: [{
      name: 'Username',
      fieldID: 'username',
      type: 'text',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }, {
      name: 'Password',
      fieldID: 'password',
      type: 'password',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }, {
      name: 'With MFA',
      fieldID: 'with-mfa',
      type: 'select',
      description: '',
      values: {
        with: 'With MFA',
        without: 'Without MFA'
      },
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: 'with',
      optional: false
    }, {
      name: 'With second MFA',
      fieldID: 'with-second-mfa',
      type: 'select',
      description: '',
      values: {
        cba: 'With second CBA-like MFA',
        none: 'Without second MFA'
      },
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: 'none',
      optional: false
    }],
    status: 'We are currently experiencing issues in retrieving data from this institution. If you experience any problems, please try again later.',
    searchVal: 'bankofmfademotest',
    exportWithPassword: false,
    requiresPreload: false,
    requiresMfa: true,
    isBusinessBank: false,
    region: '',
    display: false
  }, {
    slug: 'bank_of_mortgage',
    name: 'Bank of Mortgage',
    credentials: [{
      name: 'Username',
      fieldID: 'username',
      type: 'text',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }, {
      name: 'Password',
      fieldID: 'password',
      type: 'password',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }],
    status: '',
    searchVal: 'testbankofmortgagedemonstration',
    exportWithPassword: false,
    requiresPreload: false,
    requiresMfa: false,
    isBusinessBank: false,
    region: '',
    display: false
  }, {
    slug: 'bank_of_optmfa',
    name: 'Bank of Optional MFA',
    credentials: [{
      name: 'Username',
      fieldID: 'username',
      type: 'text',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }, {
      name: 'Password',
      fieldID: 'password',
      type: 'password',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }, {
      name: 'Token Code (date: Ymd)',
      fieldID: 'date',
      type: 'password',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: true
    }],
    status: '',
    searchVal: 'bankofoptmfabankofoptionalmfaoptionalmultifactor',
    exportWithPassword: false,
    requiresPreload: false,
    requiresMfa: false,
    isBusinessBank: false,
    region: '',
    display: false
  }, {
    slug: 'bank_of_password',
    name: 'Bank of Password',
    credentials: [{
      name: 'Username',
      fieldID: 'username',
      type: 'text',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }, {
      name: 'Password',
      fieldID: 'password',
      type: 'password',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }],
    status: '',
    searchVal: 'testbankofpassword',
    exportWithPassword: true,
    requiresPreload: false,
    requiresMfa: false,
    isBusinessBank: false,
    region: '',
    display: false
  }, {
    slug: 'bank_of_statements',
    name: 'Bank of Statements',
    credentials: [{
      name: 'Username',
      fieldID: 'username',
      type: 'text',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }, {
      name: 'Password',
      fieldID: 'password',
      type: 'password',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }],
    status: '',
    searchVal: 'testbankofstatementsdemonstration',
    exportWithPassword: false,
    requiresPreload: false,
    requiresMfa: false,
    isBusinessBank: false,
    region: '',
    display: false
  }, {
    slug: 'bank_of_transactions',
    name: 'Bank of Transactions',
    credentials: [{
      name: 'Username',
      fieldID: 'username',
      type: 'text',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: '',
      defaultKey: '',
      optional: false
    }, {
      name: 'Password',
      fieldID: 'password',
      type: 'password',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: '',
      defaultKey: '',
      optional: false
    }],
    status: '',
    searchVal: 'bankoftransactions',
    exportWithPassword: false,
    requiresPreload: false,
    requiresMfa: false,
    isBusinessBank: false,
    region: '',
    display: false
  }, {
    slug: 'bnz',
    name: 'BNZ',
    credentials: [{
      name: 'Access Number',
      fieldID: 'username',
      type: 'text',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: '',
      defaultKey: '',
      optional: false
    }, {
      name: 'Password',
      fieldID: 'password',
      type: 'password',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: '',
      defaultKey: '',
      optional: false
    }],
    status: '',
    searchVal: 'bnzbankofnewzealandbanknewzealand',
    exportWithPassword: false,
    requiresPreload: false,
    requiresMfa: false,
    isBusinessBank: false,
    region: 'nz',
    display: true
  }, {
    slug: 'coop',
    name: 'The Cooperative Bank',
    credentials: [{
      name: 'Customer Number',
      fieldID: 'username',
      type: 'text',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: '',
      defaultKey: '',
      optional: false
    }, {
      name: 'Password',
      fieldID: 'password',
      type: 'password',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: '',
      defaultKey: '',
      optional: false
    }],
    status: '',
    searchVal: 'thecooperativebank',
    exportWithPassword: false,
    requiresPreload: false,
    requiresMfa: false,
    isBusinessBank: false,
    region: 'nz',
    display: true
  }, {
    slug: 'cucentral',
    name: 'NZCU Central',
    credentials: [{
      name: 'AccessNumber',
      fieldID: 'username',
      type: 'text',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }, {
      name: 'Password',
      fieldID: 'password',
      type: 'password',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }],
    status: '',
    searchVal: 'nzcucentralnewzealandcreditunioncentral',
    exportWithPassword: false,
    requiresPreload: false,
    requiresMfa: false,
    isBusinessBank: false,
    region: 'nz',
    display: false
  }, {
    slug: 'firstcu',
    name: 'First Credit Union',
    credentials: [{
      name: 'AccessNumber',
      fieldID: 'username',
      type: 'text',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }, {
      name: 'Password',
      fieldID: 'password',
      type: 'password',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }],
    status: '',
    searchVal: 'firstcufirstcreditunionnz',
    exportWithPassword: false,
    requiresPreload: false,
    requiresMfa: false,
    isBusinessBank: false,
    region: 'nz',
    display: true
  }, {
    slug: 'fishercu',
    name: 'Fisher Credit Union',
    credentials: [{
      name: 'AccessNumber',
      fieldID: 'username',
      type: 'text',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }, {
      name: 'Password',
      fieldID: 'password',
      type: 'password',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }],
    status: '',
    searchVal: 'fishercreditunionfishercu',
    exportWithPassword: false,
    requiresPreload: false,
    requiresMfa: false,
    isBusinessBank: false,
    region: 'nz',
    display: false
  }, {
    slug: 'heartland',
    name: 'Heartland Bank',
    credentials: [{
      name: 'User ID',
      fieldID: 'username',
      type: 'text',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'number',
      defaultKey: '',
      optional: false
    }, {
      name: 'Password',
      fieldID: 'password',
      type: 'password',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }],
    status: '',
    searchVal: 'heartlandbank',
    exportWithPassword: false,
    requiresPreload: false,
    requiresMfa: false,
    isBusinessBank: false,
    region: 'nz',
    display: false
  }, {
    slug: 'kiwi',
    name: 'Kiwi Bank',
    credentials: [{
      name: 'Access Number',
      fieldID: 'username',
      type: 'text',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: '',
      defaultKey: '',
      optional: false
    }, {
      name: 'Password',
      fieldID: 'password',
      type: 'password',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: '',
      defaultKey: '',
      optional: false
    }],
    status: '',
    searchVal: 'kiwibank',
    exportWithPassword: false,
    requiresPreload: false,
    requiresMfa: true,
    isBusinessBank: false,
    region: 'nz',
    display: true
  }, {
    slug: 'nzcuauckland',
    name: 'NZCU Auckland',
    credentials: [{
      name: 'AccessNumber',
      fieldID: 'username',
      type: 'text',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }, {
      name: 'Password',
      fieldID: 'password',
      type: 'password',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }],
    status: '',
    searchVal: 'nzcuauckland',
    exportWithPassword: false,
    requiresPreload: false,
    requiresMfa: false,
    isBusinessBank: false,
    region: 'nz',
    display: false
  }, {
    slug: 'nzcubaywide',
    name: 'NZCU Baywide',
    credentials: [{
      name: 'AccessNumber',
      fieldID: 'username',
      type: 'text',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }, {
      name: 'Password',
      fieldID: 'password',
      type: 'password',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }],
    status: '',
    searchVal: 'nzcubaywide',
    exportWithPassword: false,
    requiresPreload: false,
    requiresMfa: false,
    isBusinessBank: false,
    region: 'nz',
    display: true
  }, {
    slug: 'nzcuemployees',
    name: 'NZCU Employees',
    credentials: [{
      name: 'AccessNumber',
      fieldID: 'username',
      type: 'text',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }, {
      name: 'Password',
      fieldID: 'password',
      type: 'password',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }],
    status: '',
    searchVal: 'nzcuemployees',
    exportWithPassword: false,
    requiresPreload: false,
    requiresMfa: false,
    isBusinessBank: false,
    region: 'nz',
    display: false
  }, {
    slug: 'nzcusouth',
    name: 'NZCU South',
    credentials: [{
      name: 'AccessNumber',
      fieldID: 'username',
      type: 'text',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }, {
      name: 'Password',
      fieldID: 'password',
      type: 'password',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }],
    status: '',
    searchVal: 'nzcusouth',
    exportWithPassword: false,
    requiresPreload: false,
    requiresMfa: false,
    isBusinessBank: false,
    region: 'nz',
    display: false
  }, {
    slug: 'nzcusteelsands',
    name: 'NZCU Steelsands',
    credentials: [{
      name: 'AccessNumber',
      fieldID: 'username',
      type: 'text',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }, {
      name: 'Password',
      fieldID: 'password',
      type: 'password',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }],
    status: '',
    searchVal: 'nzcusteelsands',
    exportWithPassword: false,
    requiresPreload: false,
    requiresMfa: false,
    isBusinessBank: false,
    region: 'nz',
    display: false
  }, {
    slug: 'nzfirecu',
    name: 'New Zealand Firefighters Credit Union',
    credentials: [{
      name: 'AccessNumber',
      fieldID: 'username',
      type: 'text',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }, {
      name: 'Password',
      fieldID: 'password',
      type: 'password',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }],
    status: '',
    searchVal: 'newzealandfirefighterscreditunionnzfirecu',
    exportWithPassword: false,
    requiresPreload: false,
    requiresMfa: false,
    isBusinessBank: false,
    region: 'nz',
    display: false
  }, {
    slug: 'nzhltransact',
    name: 'New Zealand Home Loans - Transact',
    credentials: [{
      name: 'Access number',
      fieldID: 'username',
      type: 'text',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 255,
        chars: '*'
      },
      keyboardType: '',
      defaultKey: '',
      optional: false
    }, {
      name: 'Password',
      fieldID: 'password',
      type: 'password',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 255,
        chars: '*'
      },
      keyboardType: '',
      defaultKey: '',
      optional: false
    }],
    status: '',
    searchVal: 'nzhltransactnewzealandhomeloans',
    exportWithPassword: false,
    requiresPreload: false,
    requiresMfa: true,
    isBusinessBank: false,
    region: 'nz',
    display: false
  }, {
    slug: 'rabonz',
    name: 'Rabobank NZ',
    credentials: [{
      name: 'Customer Number',
      fieldID: 'username',
      type: 'text',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'number',
      defaultKey: '',
      optional: false
    }],
    status: '',
    searchVal: 'rabobanknzrabobanknewzealandrabodirectraboplus',
    exportWithPassword: false,
    requiresPreload: false,
    requiresMfa: true,
    isBusinessBank: false,
    region: 'nz',
    display: false
  }, {
    slug: 'sbs',
    name: 'SBS Bank',
    credentials: [{
      name: 'Member Number',
      fieldID: 'username',
      type: 'text',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: '',
      defaultKey: '',
      optional: false
    }, {
      name: 'Password',
      fieldID: 'password',
      type: 'password',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: '',
      defaultKey: '',
      optional: false
    }],
    status: '',
    searchVal: 'sbsbank',
    exportWithPassword: false,
    requiresPreload: false,
    requiresMfa: false,
    isBusinessBank: false,
    region: 'nz',
    display: true
  }, {
    slug: 'tsbnz',
    name: 'TSB Bank',
    credentials: [{
      name: 'Card Number',
      fieldID: 'username',
      type: 'text',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: '',
      defaultKey: '',
      optional: false
    }, {
      name: 'Password',
      fieldID: 'password',
      type: 'password',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: '',
      defaultKey: '',
      optional: false
    }],
    status: '',
    searchVal: 'tsbbank',
    exportWithPassword: false,
    requiresPreload: false,
    requiresMfa: false,
    isBusinessBank: false,
    region: 'nz',
    display: true
  }, {
    slug: 'westforce',
    name: 'Westforce Credit Union',
    credentials: [{
      name: 'User',
      fieldID: 'username',
      type: 'text',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }, {
      name: 'Password',
      fieldID: 'password',
      type: 'password',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: 'default',
      defaultKey: '',
      optional: false
    }],
    status: '',
    searchVal: 'westforcecreditunionwestforcecu',
    exportWithPassword: false,
    requiresPreload: false,
    requiresMfa: false,
    isBusinessBank: false,
    region: 'nz',
    display: false
  }, {
    slug: 'westpacnz',
    name: 'Westpac New Zealand',
    credentials: [{
      name: 'Customer ID',
      fieldID: 'username',
      type: 'text',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: '',
      defaultKey: '',
      optional: false
    }, {
      name: 'Password',
      fieldID: 'password',
      type: 'password',
      description: '',
      values: {},
      validation: {
        minLength: 0,
        maxLength: 9999999,
        chars: '*'
      },
      keyboardType: '',
      defaultKey: '',
      optional: false
    }],
    status: '',
    searchVal: 'westpacnz',
    exportWithPassword: false,
    requiresPreload: false,
    requiresMfa: false,
    isBusinessBank: false,
    region: 'nz',
    display: true
  }]
};
var _default = institutionList;
exports.default = _default;